/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { Page, Text, View, Document, StyleSheet, Image, Font } from "@react-pdf/renderer";
import Constants from "../../utilities/Constants";
import Strings from "../../utilities/Strings";
import Utils from "../../utilities/Utils";

const UtilsInstance = new Utils();

Font.register({ family: "RobotoRegular", src: `${process.env.PUBLIC_URL}/fonts/roboto-v20-latin-regular.ttf` });
Font.register({ family: "RobotoMedium", src: `${process.env.PUBLIC_URL}/fonts/Roboto-Medium.ttf` });

let actualPageCounter = 1;
let livelistCounter = 1;

class H1Report extends Component {

  constructor(props) {
    super(props);

    this.state = {
      generatingDate: new Date(),
      // Summary
      firstLiveListPage: -1,
      firstOscilloscopePage: -1,
      firstBarGraphPage: -1,
      firstLogPage: -1,
    };
  }

  // ------------------------ Utilities -------------------------
  getAnalysisInit = () => {
    let drawDate = this.whenWasTurnedOnAsDate(this.props.uptime);
    let year = drawDate.getFullYear();
    let month = drawDate.getMonth() + 1;
    let day = drawDate.getDate();
    let hour = drawDate.getHours();
    let minutes = drawDate.getMinutes();
    let seconds = drawDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  whenWasTurnedOnAsDate = (uptimeInSeconds) => {
    if (uptimeInSeconds !== undefined) {
      const uptimeInMillis = uptimeInSeconds * 1000;
      const timeNow = new Date().getTime();
      const whenWasTurnedOn = timeNow - uptimeInMillis;
      const dateWhenWasTurnedOn = new Date(whenWasTurnedOn);
      return dateWhenWasTurnedOn;
    }
  }

  getDateNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = this.state.generatingDate.getMonth() + 1;
    let day = this.state.generatingDate.getDate();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }

    return (day + "/" + month + "/" + year);
  }


  incrementPageCount = () => {
    actualPageCounter++;
  }

  incrementPageCountBarGraph = () => {
    if (this.props.ampImgURIs[0].length > 0) {
      let numOfPages = Math.floor((this.props.ampImgURIs[0].length * 5) / 2);
      actualPageCounter = actualPageCounter + numOfPages;
    }
    else {
      actualPageCounter = actualPageCounter + 1;
    }
  }

  getRectImage = (isFilled) => {
    if (isFilled) {
      return <Image src={`${process.env.PUBLIC_URL}/images/filled-rect.png`} style={styles.rectStyle} />;
    }
    else {
      return <Image src={`${process.env.PUBLIC_URL}/images/empty-rect.png`} style={styles.rectStyle} />;
    }
  }

  getDateTimeNow = () => {
    let year = this.state.generatingDate.getFullYear();
    let month = (this.state.generatingDate.getMonth() + 1);
    let day = this.state.generatingDate.getDate();
    let hour = this.state.generatingDate.getHours();
    let minutes = this.state.generatingDate.getMinutes();
    let seconds = this.state.generatingDate.getSeconds();

    if (day < 10) { day = "0" + day; }
    if (month < 10) { month = "0" + month; }
    if (hour < 10) { hour = "0" + hour; }
    if (minutes < 10) { minutes = "0" + minutes; }
    if (seconds < 10) { seconds = "0" + seconds; }

    return (day + "/" + month + "/" + year + " " + hour + ":" + minutes + ":" + seconds);
  }

  getAmplitudeText = (amplitude) => {
    if (amplitude !== undefined && amplitude !== null) {
      return amplitude.toFixed(2) + " " + Strings.MILLIVOLT;
    }
  }

  getStatusText = (status) => {
    if (status === Constants.GOOD) {
      return Strings.GOOD_STRING;
    }
    else if (status === Constants.ATTENTION) {
      return Strings.ATTENTION_STRING;
    }
    else if (status === Constants.BAD) {
      return Strings.BAD_STRING;
    }
    else if (status === Constants.FAULT) {
      return Strings.FAULT_STRING;
    }
    else {
      return Strings.UNKNOWN_STRING;
    }
  }

  getClientImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a client image
    if (this.props.userInput.clientImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.clientImg} />
      );
    }
  }

  getExecutorImage = () => {
    // Only try to draw the Image on the pdf if the user has
    // submited a executor image
    if (this.props.userInput.executorImg !== "") {
      return (
        <Image style={{
          maxHeight: "100pt",
          width: "100pt"
        }} src={this.props.userInput.executorImg} />
      );
    }
  }

  // ----------------- Create Report -----------------
  createReport = () => {
    return (
      <Document
        title={Strings.REPORT_EXPORT_NAME}>
        {this.createGeneralInfoPage()}
        {this.createDataInfoPage()}
        {this.createSummaryPage(this.props.channels[0])}
        {this.createChannelPage(this.props.channels[0])}
        {this.createLiveListPages(this.props.livelist[0])}
        {this.createOscilloscopePages(this.props.imgURIs[0], this.props.livelistMap[0])}
        {this.createBarGraphPages(
          this.props.ampImgURIs[0],
          this.props.noiseImgURIs[0],
          this.props.jitterImgURIs[0],
          this.props.unbalanceImgURIs[0]
        )}
        {this.createLogPages(this.props.log[0])}
        {this.createDisclaimerPage()}
      </Document>
    );
  }

  // ----------------- Header for all the pages -----------------
  getPageHeader = () => {
    return (
      <View fixed>
        <View style={styles.pageHeaderStyle}>
          <Image src={`${process.env.PUBLIC_URL}/logo_report.png`} style={styles.logoImgStyle} />
          <Text style={styles.pageHeaderTextStyle}>{Strings.HEADER_TEXT}</Text>
        </View>
        <View style={styles.lineStyle}></View>
      </View>
    );
  }

  // ----------------- Footer for all the pages -----------------
  getPageFooter = () => {
    return (
      <View style={styles.pageFooterStyle} fixed>
        <View style={styles.footerLineStyle}></View>
        <View>
          <Text style={styles.footerTextStyle} render={({ pageNumber, totalPages }) => (
            `${this.getDateNow()}, Página ${pageNumber} / ${totalPages}`
          )} fixed />
        </View>
      </View>
    );
  }

  // ----------------- General Information -----------------
  createGeneralInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.getPageHeader()}

        <Text style={styles.summaryPageTitle}>{Strings.GENERAL_REPORT}</Text>

        <Text style={styles.subHeaderTextStyle}>{Strings.CLIENT_INFO}</Text>

        <View style={styles.subHeaderLineStyle} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={styles.normalTextStyle}>{Strings.PROJECT_NAME} {this.props.userInput.clientProjectName}</Text>
            <Text style={styles.normalTextStyle}>{Strings.NETWORK_NAME} {this.props.userInput.clientNetworkName}</Text>
            <Text style={styles.normalTextStyle}>{Strings.LOCATION} {this.props.userInput.clientLocation}</Text>
            <Text style={styles.normalTextStyle}>{Strings.COMPANY_NAME} {this.props.userInput.clientCompanyName}</Text>
            <Text style={styles.normalTextStyle}>{Strings.ACCOUNTABLE_NAME} {this.props.userInput.clientAccountableName}</Text>
            <Text style={styles.normalTextStyle}>{Strings.COMPANY_ADDRESS} {this.props.userInput.clientAddress}</Text>
            <Text style={styles.normalTextStyle}>{Strings.COMPANY_CITY} {this.props.userInput.clientCity}</Text>
            <Text style={styles.lastInfoTextStyle}>{Strings.COMPANY_TEL} {this.props.userInput.clientTel}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getClientImage()}
          </View>
        </View>

        <Text style={styles.subHeaderTextStyle}>{Strings.EXECUTING_COMPANY_INFO}</Text>

        <View style={styles.subHeaderLineStyle} />

        <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center" }} >

          <View style={{ maxWidth: "400pt" }}>
            <Text style={styles.normalTextStyle}>{Strings.EXECUTING_COMPANY_NAME} {this.props.userInput.executingCompanyName}</Text>
            <Text style={styles.normalTextStyle}>{Strings.EXECUTING_ACCOUNTABLE_NAME} {this.props.userInput.executingAccountableName}</Text>
            <Text style={styles.normalTextStyle}>{Strings.EXECUTING_TEL} {this.props.userInput.executingTel}</Text>
            <Text style={styles.lastInfoTextStyle}>{Strings.EXECUTING_EMAIL} {this.props.userInput.executingEmail}</Text>
          </View>

          <View style={{ maxWidth: "100pt" }}>
            {this.getExecutorImage()}
          </View>
        </View>

        <Text style={styles.subHeaderTextStyle}>{Strings.ANNOTATIONS}</Text>

        <View style={styles.subHeaderLineStyle} />

        <View style={styles.notesContainerStyle}>
          <Text style={styles.normalTextStyle}>{this.props.userInput.notes}</Text>
        </View>

        <Text style={styles.subHeaderTextStyle}>{Strings.CONCLUSION}</Text>

        <View style={styles.subHeaderLineStyle} />

        <View style={styles.conclusionSectionStyle}>

          <View>

            <View style={styles.rectSectionStyle}>
              {this.getRectImage(this.props.conformity === Constants.CONFORM)}
              <Text style={styles.normalTextStyle}>{Strings.CONFORM}</Text>
            </View>

            <View style={styles.rectSectionStyle}>
              {this.getRectImage(this.props.conformity === Constants.CONFORM_W_RESTRICTION)}
              <Text style={styles.normalTextStyle}>{Strings.CONFORM_W_RESTRICTION}</Text>
            </View>

            <View style={styles.rectSectionStyle}>
              {this.getRectImage(this.props.conformity === Constants.NON_CONFORM)}
              <Text style={styles.normalTextStyle}>{Strings.NON_CONFORM}</Text>
            </View>

          </View>

          <View style={styles.signLineStyle} />

        </View>

        {this.getPageFooter()}

        {this.incrementPageCount()}

      </Page >
    );
  }

  // ----------------- Data Information -----------------
  createDataInfoPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.getPageHeader()}

        <Text style={styles.summaryPageTitle}>{Strings.DATA_REPORT}</Text>

        <Text style={styles.subHeaderTextStyle2}>{Strings.CHANNEL} {this.props.channels[0]}</Text>
        <View style={styles.subHeaderLineStyle} />

        <Text style={styles.normalTextStyle}>{Strings.PHYSICAL_ENVIRONMENT} {Strings.PHYSICAL_ENVIRONMENT_TYPE}</Text>
        <Text style={styles.normalTextStyle}>{Strings.ANALYZER_VERSION_STRING} {Constants.SOFTWARE_VERSION}</Text>
        <Text style={styles.normalTextStyle}>{Strings.ANALYSIS_INIT} {this.getAnalysisInit()}</Text>
        <Text style={styles.normalTextStyle}>{Strings.REPORT_GENERATION} {this.getDateTimeNow()}</Text>
        <Text style={styles.normalTextStyle}>{Strings.BAUD_RATE} {Constants.H1_BAUD_RATE} {Strings.KBPS}</Text>
        <Text style={styles.normalTextStyle}>{Strings.NUM_MASTERS} {this.props.networkData[0].nMasters}</Text>
        <Text style={styles.normalTextStyle}>{Strings.NUM_SLAVES} {this.props.networkData[0].nSlaves}</Text>
        <Text style={styles.normalTextStyle}>- {Strings.SCOPE_TAG} {this.props.scopeTag} </Text>
        <Text style={styles.lastInfoTextStyle}>{Strings.CHANNEL_TAG} {this.props.channelTag} </Text>

        <Text style={styles.subHeaderTextStyle}>{Strings.ETHERNET_INFO}</Text>
        <View style={styles.subHeaderLineStyle} />

        <Text style={styles.normalTextStyle}>{Strings.IP_DP}{this.props.configData.addr} </Text>
        <Text style={styles.normalTextStyle}>{Strings.MASK_DP}{this.props.configData.netmask} </Text>
        <Text style={styles.lastInfoTextStyle}>{Strings.GATEWAY_DP}{this.props.configData.gateway} </Text>

        <Text style={styles.subHeaderTextStyle}>{Strings.WLAN_INFO}</Text>
        <View style={styles.subHeaderLineStyle} />

        <Text style={styles.normalTextStyle}>{Strings.NETWORK_NAME_DP}{this.props.wifiConfigData.wifiName}</Text>
        <Text style={styles.normalTextStyle}>{Strings.IP_DP}{this.props.wifiConfigData.wifiAddr}</Text>
        <Text style={styles.normalTextStyle}>{Strings.MASK_DP}{this.props.wifiConfigData.wifiNetmask}</Text>
        <Text style={styles.normalTextStyle}>{Strings.GATEWAY_DP}{this.props.wifiConfigData.wifiGateway}</Text>

        {this.getPageFooter()}

        {this.incrementPageCount()}

      </Page >
    );
  }

  // ----------------- Summary -----------------
  createSummaryPage = (channel) => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.getPageHeader()}

        <Text style={styles.summaryPageTitle}>{Strings.SUMMARY}</Text>

        <Text style={styles.summaryChannelText}>{Strings.CHANNEL} {channel}</Text>

        <Text style={styles.summaryTextStyle} render={() => (
          `1. ${Strings.LIVE_LIST} ${Strings.LIVE_LIST_DOTS} ${this.state.firstLiveListPage}`
        )} />

        <Text style={styles.summaryTextStyle} render={() => (
          `2. ${Strings.OSCILLOSCOPE} ${Strings.OSC_DOTS} ${this.state.firstOscilloscopePage}`
        )} fixed />

        <Text style={styles.summaryTextStyle} render={() => (
          `3. ${Strings.BAR_GRAPH} ${Strings.BAR_DOTS} ${this.state.firstBarGraphPage}`
        )} />

        <Text style={styles.summaryTextStyle} render={() => (
          `4. ${Strings.LOG} ${Strings.LOG_DOTS} ${this.state.firstLogPage}`
        )} />

        <Text style={styles.summaryTextStyle} render={({ totalPages }) => (
          `5. ${Strings.DISCLAIMER} ${Strings.DISCLAIMER_DOTS} ${totalPages}`
        )} fixed />

        {this.getPageFooter()}

        {this.incrementPageCount()}

      </Page>
    );
  }

  createChannelPage = (channel) => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <View style={{
          height: "1px",
          width: "100px",
          backgroundColor: "black",
          marginLeft: "auto",
          marginRight: "auto"
        }}></View>

        <Text style={{
          textAlign: "center",
          fontSize: 18,
          marginTop: "2vh",
          marginBottom: "2vh",
          fontWeight: "bold",
          fontFamily: "RobotoMedium"
        }}>{Strings.CHANNEL + " " + channel}</Text>

        <View style={{
          height: "1px",
          width: "60px",
          backgroundColor: "black",
          marginLeft: "auto",
          marginRight: "auto"
        }}></View>

        {this.getPageFooter()}

        {this.incrementPageCount()}
      </Page >
    );
  }

  // ----------------- Live List -----------------
  createLiveListPages = (livelist) => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.setLiveListFirstPageNumber(actualPageCounter)}

        {this.getPageHeader()}

        <Text style={styles.pageTitle} fixed>{Strings.LIVE_LIST_PAGE_TITLE}</Text>

        <View style={styles.table}>
          {this.createLiveListTableHeader()}
          {this.createLiveListTable(livelist)}
        </View>

        {this.getPageFooter()}

        {this.incrementPageCount()}

      </Page>
    );
  }

  setLiveListFirstPageNumber = (pageNumber) => {
    if (this.state.firstLiveListPage === -1) {
      this.setState({ firstLiveListPage: pageNumber });
    }
  }

  createLiveListTableHeader = () => {
    return (
      <View style={styles.tableRow} fixed>

        <View style={styles.tableColHeader1}>
          <Text style={styles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={styles.tagTableColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.TAG}</Text>
        </View>

        <View style={styles.tableColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.AMPLITUDE}</Text>
        </View>

        <View style={styles.tableColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.MIN_AMPLITUDE}</Text>
        </View>

        <View style={styles.devNoiseTableColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.NOISE}</Text>
        </View>

        <View style={styles.devJitterTableColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.JITTER}</Text>
        </View>

        <View style={styles.devUnbalanceTableColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.UNBALANCE}</Text>
        </View>

        <View style={styles.tableStatusColHeader}>
          <Text style={styles.tableCellHeader}>{Strings.SIGNAL}</Text>
        </View>

      </View>
    );
  }

  createLiveListTable = (livelist) => {
    return (
      livelist.map(device => (
        <View style={styles.tableRow} key={device.address} wrap={false}>
          <View style={styles.tableCol1}>
            <Text style={styles.tableCell}>{device.address}{UtilsInstance.getMasterSuffix(device.isMaster)}</Text>
          </View>

          <View style={styles.tagTableCol}>
            <Text style={styles.tableCell}>{device.tag}</Text>
          </View>

          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{this.getAmplitudeText(device.amplitude)}</Text>
          </View>

          <View style={styles.tableCol}>
            <Text style={styles.tableCell}>{this.getAmplitudeText(device.amplitudeMin)}</Text>
          </View>

          <View style={styles.noiseTableCol}>
            <Text style={styles.tableCell}>{this.getAmplitudeText(device.noise)}</Text>
          </View>

          <View style={styles.jitterTableCol}>
            <Text style={styles.tableCell}>{device.jitter.toFixed(2) + Strings.MICROSSECOND}</Text>
          </View>

          <View style={styles.unbalanceTableCol}>
            <Text style={styles.tableCell}>{device.unbalance.toFixed(2) + " %"}</Text>
          </View>

          {this.createStatusCell(device)}

          {this.countLiveListPageElements()}
        </View>
      ))
    );
  }

  countLiveListPageElements = () => {
    if (livelistCounter === Constants.LIVE_LIST_ELEMENTS_PER_PAGE) {
      livelistCounter = 1;
      this.incrementPageCount();
    }
    else {
      livelistCounter++;
    }
  }

  createStatusCell = (device) => {
    if (device.status === Constants.GOOD) {
      if (device.hasWaveProblem) {
        return (
          <View style={styles.okFadedTableStatusCol}>
            <Text style={styles.tableCell}>
              {Strings.GOOD_STRING}
            </Text>
          </View>
        );
      }
      else {
        return (
          <View style={styles.okTableStatusCol}>
            <Text style={styles.tableCell}>
              {Strings.GOOD_STRING}
            </Text>
          </View>
        );
      }
    }
    else if (device.status === Constants.ATTENTION) {
      if (device.hasWaveProblem) {
        return (
          <View style={styles.attentionFadedTableStatusCol}>
            <Text style={styles.tableCell}>
              {Strings.ATTENTION_STRING}
            </Text>
          </View>
        );
      }
      else {
        return (
          <View style={styles.attentionTableStatusCol}>
            <Text style={styles.tableCell}>
              {Strings.ATTENTION_STRING}
            </Text>
          </View>
        );
      }
    }
    else if (device.status === Constants.BAD) {
      if (device.hasWaveProblem) {
        return (
          <View style={styles.badFadedTableStatusCol}>
            <Text style={styles.tableCell}>
              {Strings.BAD_STRING}
            </Text>
          </View>
        );
      }
      else {
        return (
          <View style={styles.badTableStatusCol}>
            <Text style={styles.tableCell}>
              {Strings.BAD_STRING}
            </Text>
          </View>
        );
      }
    }
    else if (device.status === Constants.FAULT) {
      return (
        <View style={styles.faultTableStatusCol}>
          <Text style={styles.tableCell}>
            {Strings.FAULT_STRING}
          </Text>
        </View>
      );
    }
    else {
      return (
        <View style={styles.unknownTableStatusCol}>
          <Text style={styles.tableCell}>
            {Strings.UNKNOWN_STRING}
          </Text>
        </View>
      );
    }
  }

  // ----------------- Oscilloscope -----------------
  createOscilloscopePages = (imgURIs, livelistMap) => {
    
    if (!imgURIs.length) {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={styles.page}>
  
          {this.getPageHeader()}
          <Text style={styles.pageTitle} fixed>{Strings.OSCILLOSCOPE_PAGE_TITLE}</Text>
  
          {this.setOscilloscopeFirstPageNumber(actualPageCounter)}

          {this.incrementPageCount()}
  
          {this.getPageFooter()}
        </Page>
      );
    }
    else {
      return (
        <Page
          size="A4"
          orientation="portrait"
          wrap={true}
          style={styles.page}>
  
          {this.getPageHeader()}
          <Text style={styles.pageTitle} fixed>{Strings.OSCILLOSCOPE_PAGE_TITLE}</Text>
  
          {this.setOscilloscopeFirstPageNumber(actualPageCounter)}

          {this.createOscilloscopeImages(imgURIs, livelistMap)}
  
          {this.getPageFooter()}
        </Page>
      );
    }
  }

  setOscilloscopeFirstPageNumber = (pageNumber) => {
    if (this.state.firstOscilloscopePage === -1) {
      this.setState({ firstOscilloscopePage: pageNumber });
    }
  }

  getSlaveMasterText = (isMaster) => {
    if (isMaster) {
      return Strings.MASTER_H1;
    }
    else {
      return Strings.SLAVE_H1;
    }
  }

  createOscilloscopeImages = (imgURIs, livelistMap) => {
    return (
      imgURIs.map(data => (
        <View key={data.address} wrap={false}>
          <Text style={styles.normalTextStyle}>
            {this.getSlaveMasterText(livelistMap.get(data.address).isMaster)} {data.address}
          </Text>

          <Text style={styles.normalTextStyle}>
            {Strings.SIGNAL_H1} {this.getStatusText(livelistMap.get(data.address).status)}
          </Text>

          <Text style={styles.normalTextStyle}>
            {Strings.AMPLITUDE_H1} {livelistMap.get(data.address).amplitude.toFixed(0) + " " + Strings.MILLIVOLT}
          </Text>

          <Text style={styles.normalTextStyle}>
            {Strings.AMPLITUDE_MIN_H1} {livelistMap.get(data.address).amplitudeMin.toFixed(0) + " " + Strings.MILLIVOLT}
          </Text>

          <Text style={styles.normalTextStyle}>
            {Strings.NOISE_H1} {livelistMap.get(data.address).noise.toFixed(0) + " " + Strings.MILLIVOLT}
          </Text>

          <Text style={styles.normalTextStyle}>
            {Strings.JITTER_H1} {livelistMap.get(data.address).jitter.toFixed(2) + Strings.MICROSSECOND}
          </Text>

          <Text style={styles.normalTextStyle}>
            {Strings.UNBALANCE_H1} {livelistMap.get(data.address).unbalance.toFixed(2) + " %"}
          </Text>

          <Image src={data.wave.imgURI} style={oscilloscopeStyles.chartImgStyle} />

          {this.incrementPageCount()}
        </View >

      ))
    );
  }

  // ----------------- Bar Graph -----------------
  createBarGraphPages = (ampImgURIs, noiseImgURIs, jitterImgURIs, unbalanceImgURIs) => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.setBarGraphFirstPageNumber(actualPageCounter)}

        {this.getPageHeader()}
        <Text style={styles.pageTitle} fixed>{Strings.BAR_GRAPH_PAGE_TITLE}</Text>

        <Text style={ampStyles.waveTitle}>{Strings.AMPLITUDE}</Text>
        {this.createBarGraphAmpImages(ampImgURIs)}

        <Text style={ampStyles.waveTitle}>{Strings.NOISE}</Text>
        {this.createBarGraphNoiseImages(noiseImgURIs)}

        <Text style={ampStyles.waveTitle}>{Strings.JITTER}</Text>
        {this.createBarGraphJitterImages(jitterImgURIs)}

        <Text style={ampStyles.waveTitle}>{Strings.UNBALANCE}</Text>
        {this.createBarGraphUnbalanceImages(unbalanceImgURIs)}

        {this.incrementPageCountBarGraph()}

        {this.getPageFooter()}
      </Page>
    );
  }

  setBarGraphFirstPageNumber = (pageNumber) => {
    if (this.state.firstBarGraphPage === -1) {
      this.setState({ firstBarGraphPage: pageNumber });
    }
  }

  createBarGraphAmpImages = (ampImgURIs) => {
    return (
      ampImgURIs.map(data => (
        <Image key={Math.floor(Math.random() * Constants.RANDOMIZER_CONSTANT)} src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  createBarGraphNoiseImages = (noiseImgURIs) => {
    return (
      noiseImgURIs.map(data => (
        <Image key={Math.floor(Math.random() * Constants.RANDOMIZER_CONSTANT)} src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  createBarGraphJitterImages = (jitterImgURIs) => {
    return (
      jitterImgURIs.map(data => (
        <Image key={Math.floor(Math.random() * Constants.RANDOMIZER_CONSTANT)} src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  createBarGraphUnbalanceImages = (unbalanceImgURIs) => {
    return (
      unbalanceImgURIs.map(data => (
        <Image key={Math.floor(Math.random() * Constants.RANDOMIZER_CONSTANT)} src={data.imgURI} style={ampStyles.chartImgStyle} />
      ))
    );
  }

  // ----------------- Log -----------------
  createLogPages = (log) => {
    return (
      <Page
        size="A4"
        orientation="landscape"
        wrap={true}
        style={styles.page}>

        {this.setLogFirstPageNumber(actualPageCounter)}


        {this.getPageHeader()}

        <Text style={monitoringLogStyles.pageTitle} fixed>{Strings.LOG_PAGE_TITLE}</Text>
        <Text style={monitoringLogStyles.pageLastEventsText} fixed>{Strings.LAST_200_EVENTS}</Text>

        <View style={monitoringLogStyles.table}>
          {this.createMonitoringLogTableHeader()}
          {this.createMonitoringLogTable(log)}
        </View>

        {this.getPageFooter()}

      </Page>
    );
  }

  createMonitoringLogTableHeader = () => {
    return (
      <View style={monitoringLogStyles.tableRow} fixed>

        <View style={monitoringLogStyles.horaryTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.HORARY}</Text>
        </View>

        <View style={monitoringLogStyles.addressTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.ADDRESS}</Text>
        </View>

        <View style={monitoringLogStyles.typeTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.TYPE}</Text>
        </View>

        <View style={monitoringLogStyles.descriptionTableColHeader}>
          <Text style={monitoringLogStyles.tableCellHeader}>{Strings.DESCRIPTION}</Text>
        </View>

      </View>
    );
  }

  createMonitoringLogTable = (log) => {
    return (
      log.map(logEntry => (
        <View wrap={false} key={logEntry.event}>
          <View style={monitoringLogStyles.tableRow} key={logEntry.event}>

            <View style={monitoringLogStyles.horaryTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.formatTime(logEntry)}</Text>
            </View>

            <View style={monitoringLogStyles.addressTableCol}>
              {logEntry.type === Constants.H1_INVERTED_POLARITY_PROBLEM_TYPE ? (
                <Text style={monitoringLogStyles.tableCell}>{logEntry.address}</Text>
              ) : (
                <Text style={monitoringLogStyles.tableCell}></Text>
              )}
            </View>

            <View style={monitoringLogStyles.typeTableCol}>
              <Text style={monitoringLogStyles.tableCell}>{this.getTypeText(logEntry.type)}</Text>
            </View>

            <View style={monitoringLogStyles.descriptionTableCol}>
              <Text style={monitoringLogStyles.tableCell}>
                {this.getDescriptionText(logEntry.type, logEntry.active)}
              </Text>
            </View>
          </View>
        </View>
      ))
    );
  }

  setLogFirstPageNumber = (pageNumber) => {
    if (this.state.firstLogPage === -1) {
      this.setState({ firstLogPage: pageNumber });
    }
  }

  getTypeText = (problemType) => {
    if (problemType === Constants.H1_TERMINATION_OFF_PROBLEM_TYPE) {
      return Strings.H1_TERMINATOR_OFF_LIST_HEADER;
    }
    else if (problemType === Constants.H1_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return Strings.H1_CAPACITIVE_EFFECT_LIST_HEADER;
    }
    else if (problemType === Constants.H1_NOISE_PROBLEM_TYPE) {
      return Strings.H1_NOISE_LIST_HEADER;
    }
    else if (problemType === Constants.H1_INVERTED_POLARITY_PROBLEM_TYPE) {
      return Strings.H1_INVERTED_POLARITY_LIST_HEADER;
    }
    else if (problemType === Constants.H1_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return Strings.H1_HIGH_RESISTANCE_LIST_HEADER;
    }
    else if (problemType === Constants.H1_UNBALANCE_PROBLEM_TYPE) {
      return Strings.H1_UNBALANCE_LIST_HEADER;
    }
    else {
      return Strings.UNKNOWN;
    }
  }

  getDescriptionText = (problemType, isActive) => {
    if (problemType === Constants.H1_TERMINATION_OFF_PROBLEM_TYPE) {
      return isActive ? Strings.H1_TERMINATION_OFF_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.H1_CAPACITIVE_EFFECT_PROBLEM_TYPE) {
      return isActive ? Strings.H1_CAPACITIVE_EFFECT_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.H1_NOISE_PROBLEM_TYPE) {
      return isActive ? Strings.H1_NOISE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.H1_INVERTED_POLARITY_PROBLEM_TYPE) {
      return isActive ? Strings.H1_INVERTED_POLARITY_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.H1_HIGH_RESISTANCE_PROBLEM_TYPE) {
      return isActive ? Strings.H1_HIGH_RESISTANCE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
    else if (problemType === Constants.H1_UNBALANCE_PROBLEM_TYPE) {
      return isActive ? Strings.H1_UNBALANCE_LOG_DESCRIPTION : Strings.EVENT_CHECKED_SUCCESS;
    }
  }

  formatTime = (logEntry) => {
    if (logEntry.ntp !== null && logEntry.ntp === true) {
      let parsedMillis = Date.parse(logEntry.time);
      let dateToShow = new Date(parsedMillis);
      return dateToShow.toLocaleString("pt-BR");
    }
    else if (logEntry.time !== undefined && logEntry.time !== null) {
      let timeNow = new Date().getTime();
      const eventTimeInMillis = logEntry.time * 1000;
      const time = timeNow - eventTimeInMillis;
      const dateToShow = new Date(time);
      return (dateToShow.toLocaleString("pt-BR"));
    }
    else {
      return Strings.BEFORE_MONITOR_INIT_STR;
    }
  }

  // ----------------- Disclaimer -----------------
  createDisclaimerPage = () => {
    return (
      <Page
        size="A4"
        orientation="portrait"
        wrap={true}
        style={styles.page}>

        {this.getPageHeader()}

        <View style={{ marginTop: "30vh" }} />

        <Text style={styles.summaryPageTitle}>{Strings.END_OF_REPORT}</Text>

        <View style={{ marginTop: "25vh" }} />

        <Text style={{
          fontSize: 14,
          fontFamily: "RobotoMedium",
          marginBottom: "5px"
        }}>
          {Strings.DISCLAIMER}
        </Text>

        <View style={styles.subHeaderLineStyle} />

        <Text
          style={{
            fontSize: 12,
            marginBottom: 2,
            fontFamily: "RobotoRegular",
            textAlign: "justify"
          }}>
          {Strings.DISCLAIMER_TEXT}
        </Text>

        {this.getPageFooter()}
      </Page >
    );
  }

  // ----------------- Lifecycle Methods ----------------
  componentDidMount() {
    livelistCounter = 1;
  }

  render() {
    actualPageCounter = 1;
    livelistCounter = 1;
    return (
      this.createReport()
    );
  }
}

const styles = StyleSheet.create({
  pdfViewer: {
    width: "90vw",
    height: "90vh"
  },

  page: {
    paddingTop: 16,
    paddingHorizontal: 40,
    paddingBottom: 56
  },

  table: {
    display: "table",
    width: "auto",
    alignItems: "center",
    justifyContent: "center"
  },

  tableRow: {
    flexDirection: "row"
  },

  tableColHeader1: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    backgroundColor: "#bdbdbd"
  },

  tagTableColHeader: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  devNoiseTableColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  devJitterTableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  devUnbalanceTableColHeader: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableStatusColHeader: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCol1: {
    width: "11%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  tagTableCol: {
    width: "15%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  noiseTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  jitterTableCol: {
    width: "10%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  unbalanceTableCol: {
    width: "16%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  nonStdDeviationTableCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#ff6600"
  },

  okTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime"
  },

  okFadedTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lime",
    opacity: 0.5
  },

  attentionTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow"
  },

  attentionFadedTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "yellow",
    opacity: 0.5
  },

  badTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722"
  },

  badFadedTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "#FF5722",
    opacity: 0.5
  },

  faultTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "darkgrey"
  },

  unknownTableStatusCol: {
    width: "12%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0,
    backgroundColor: "lightgrey"
  },

  tableCellHeader: {
    textAlign: "center",
    marginTop: 4,
    marginBottom: 4,
    fontSize: 12,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  tableCell: {
    textAlign: "center",
    margin: 5,
    fontSize: 10,
    fontFamily: "RobotoRegular"
  },

  logoImgStyle: {
    width: "92pt",
    height: "30pt",
    marginBottom: "6pt"
  },

  pageHeaderStyle: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center"
  },

  pageHeaderTextStyle: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  lineStyle: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "2vh"
  },

  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontFamily: "RobotoMedium"
  },

  summaryPageTitle: {
    textAlign: "center",
    fontSize: 18,
    marginTop: "2vh",
    marginBottom: "4vh",
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  pdfLinkStyle: {
    marginLeft: "2vw"
  },

  subHeaderTextStyle: {
    fontSize: 12,
    fontFamily: "RobotoMedium"
  },

  subHeaderTextStyle2: {
    fontSize: 12,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  subHeaderLineStyle: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "0.5vh",
    marginBottom: "2vh"
  },

  normalTextStyle: {
    fontSize: 12,
    marginBottom: 2,
    fontFamily: "RobotoRegular"
  },

  lastInfoTextStyle: {
    fontSize: 12,
    marginBottom: "2vh",
    fontFamily: "RobotoRegular"
  },

  notesContainerStyle: {
    maxWidth: "510pt",
    width: "90vw",
    height: "14vh"
  },

  summaryTextStyle: {
    fontSize: 12,
    marginBottom: "1vh",
    fontFamily: "RobotoRegular"
  },

  pageFooterStyle: {
    textAlign: "right",
    position: "absolute",
    bottom: 20,
    left: 40,
    right: 40
  },

  footerLineStyle: {
    height: "1px",
    backgroundColor: "black",
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  footerTextStyle: {
    fontSize: 12,
    fontFamily: "RobotoRegular"
  },

  pageNumber: {
    position: "absolute",
    fontSize: 12,
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: "center",
    color: "grey",
  },

  rectStyle: {
    width: 28,
    height: 28,
    margin: "1vh vw"
  },

  conclusionSectionStyle: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    height: "16vh"
  },

  rectSectionStyle: {
    display: "inline-flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  },

  signLineStyle: {
    height: "1px",
    width: "40vw",
    backgroundColor: "black",
  },

  summaryChannelText: {
    fontSize: 12,
    textAlign: "center",
    marginBottom: "1vh",
    fontFamily: "RobotoMedium"
  },
});

const oscilloscopeStyles = StyleSheet.create({
  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16,
    marginTop: "1vh",
    marginBottom: "1vh"
  },

  chartImgStyle: {
    marginTop: "2vh",
    height: "28vh",
    width: "87vw"
  }
});

const ampStyles = StyleSheet.create({
  waveTitle: {
    textAlign: "center",
    fontFamily: "RobotoMedium",
    fontSize: 16
  },

  chartImgStyle: {
    height: "33vh",
    width: "87vw",
    marginTop: "1vh",
    marginBottom: "4vh"
  }
});

const monitoringLogStyles = StyleSheet.create({
  pageTitle: {
    fontSize: 18,
    marginTop: "2vh",
    fontFamily: "RobotoMedium"
  },

  pageLastEventsText: {
    fontSize: 12,
    marginBottom: "3vh",
    fontFamily: "RobotoRegular"
  },

  table: {
    display: "table",
    width: "auto"
  },

  tableRow: {
    flexDirection: "row"
  },

  horaryTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  addressTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  typeTableColHeader: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  descriptionTableColHeader: {
    width: "40%",
    borderStyle: "solid",
    borderColor: "#000",
    borderBottomColor: "#000",
    borderWidth: 1,
    bortderTopWidth: 0,
    borderLeftWidth: 0,
    backgroundColor: "#bdbdbd"
  },

  tableCellHeader: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontWeight: "bold",
    fontFamily: "RobotoMedium"
  },

  horaryTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderTopWidth: 0
  },

  addressTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  typeTableCol: {
    width: "20%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  descriptionTableCol: {
    width: "40%",
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 1,
    borderLeftWidth: 0,
    borderTopWidth: 0
  },

  tableCell: {
    textAlign: "center",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },

  tableCellLeft: {
    textAlign: "left",
    margin: 4,
    fontSize: 8,
    fontFamily: "RobotoRegular"
  },
});

export default H1Report;
